
import { diff3Merge, diffComm } from "node-diff3";
import Moment from "moment";

//import * as Diff from "diff";

export function getSim (data)
{
    return (data.simID !== null && data.sim[data.simID] !== undefined) ?
	   data.sim[data.simID] : null;
}

export function getSimParam (data, key, simID = null)
{
    const sim = simID === null ? getSim(data) : data.sim[simID];
    if (sim === null) return null;
    
    const params = JSON.parse(sim.params);
    return params[key] !== undefined ? params[key] : null;
}

export function setSimParam (data, dataDispatch, key, value)
{
    const sim = getSim(data);
    if (sim === null) return;

    let params = JSON.parse(sim.params);

    if (Array.isArray(key) || Array.isArray(value))
    {
	if (Array.isArray(key) && Array.isArray(value) && key.length === value.length)
	    for (let k = 0; k < key.length; k++) params[key[k]] = value[k];
	else return;
    }
    else params[key] = value;

    dataDispatch({ type: "upload", table: "sim", id: data.simID, data: { params } });
}

export function getCurrentTime ()
{
    return Moment().format("YYYY-MM-DD HH:mm:ss");
}

export function timeToString (time, date = true)
{
    if (date) return time.substr(8,2) + "/" + time.substr(5,2) + "/" + time.substr(0,4);
    else return time.substr(11,2) + "h" + time.substr(14,2);
}

export function currentTimeToString ()
{
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1;
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    return dd + "/" + mm + "/" + yyyy;
}


export function getDiffs (prevArticleContent, amendmentContent, articleContent = null)
{
    const diffs = [];
    const size = Math.max(amendmentContent.length, articleContent !== null ? articleContent.length : 0);
    for (let index = 0; index < size; index++)
    {
	const prevArticleParagraph = index < prevArticleContent.length ? prevArticleContent[index] : "";
	const amendmentParagraph = index < amendmentContent.length ? amendmentContent[index] : "";
	const articleParagraph = articleContent === null ? null : (index < articleContent.length ? articleContent[index] : "");

	if (articleContent !== null && amendmentParagraph === prevArticleParagraph && articleParagraph !== prevArticleParagraph) diffs.push([{ new: [articleParagraph] }]);
	else diffs.push(diffComm(prevArticleParagraph.split(/\s+/), amendmentParagraph.split(/\s+/)));
    }
    return diffs;
}

export function showDiffs (diffs, all = true)
{
    const diffContent = diffs.map((diff) => {
	return diff.flatMap((diffComm, index) => {
	    let result = [];
	    
	    if (diffComm.new !== undefined && diffComm.new.length > 0)
	    {
		const str = diffComm.new.join(" ");
		if (str !== "") result.push(<span key={"c-"+index} className="mx-1 text-secondary fw-bold">{str}</span>);
	    }

	    if (diffComm.common !== undefined && diffComm.common.length > 0)
	    {
		const str = diffComm.common.join(" ");
		if (str !== "") result.push(<span key={"c-"+index} className="">{str}</span>);
	    }

	    if (all && diffComm.buffer1 !== undefined && diffComm.buffer1.length > 0)
	    {
		const str = diffComm.buffer1.join(" ");
		if (str !== "") result.push(<span key={"b1-"+index} className="mx-1 text-danger text-decoration-line-through fw-bold">{str}</span>);
	    }

	    if (all && diffComm.buffer2 !== undefined && diffComm.buffer2.length > 0)
	    {
		const str = diffComm.buffer2.join(" ");
		if (str !== "") result.push(<span key={"b2-"+index} className="mx-1 text-success text-decoration-underline fw-bold">{str}</span>);
	    }
	    
	    if (! all && diffComm.buffer2 !== undefined && diffComm.buffer2.length > 0)
	    {
		const str = diffComm.buffer2.join(" ");
		if (str !== "") result.push(<span key={"b2-"+index} className="mx-1 fw-bold">{str}</span>);
	    }
	    
	    return result;
	});
    });

    return diffContent;
}


export function getAndShowDiffs (prevArticleContent, amendmentContent, articleContent = null, all = true)
{
    const diffs = getDiffs(prevArticleContent, amendmentContent, articleContent);
    return showDiffs(diffs, all);
}


export function computeDiffs (prevArticleContent, amendmentContent, articleContent = null)
{
    const diffs = [];
    const size = Math.max(amendmentContent.length, articleContent !== null ? articleContent.length : 0);
    for (let index = 0; index < size; index++)
    {
	const prevArticleParagraph = index < prevArticleContent.length ? prevArticleContent[index] : "";
	const amendmentParagraph = index < amendmentContent.length ? amendmentContent[index] : "";
	const articleParagraph = articleContent === null ? null : (index < articleContent.length ? articleContent[index] : "");

	if (articleContent !== null && amendmentParagraph === prevArticleParagraph && articleParagraph !== prevArticleParagraph) diffs.push(articleParagraph);
	else diffs.push(amendmentParagraph);
    }
    return diffs;
}


/* export function computeDiffs (prevArticleContent, amendmentContent1, amendmentContent2)
 * {
 *     const diffs = amendmentContent2.map((amendmentContent2Str, index) => {
 * 	const prevArticleParagraph = index < prevArticleContent.length ? prevArticleContent[index] : "";
 * 	const amendmentContent1Str = index < amendmentContent1.length ? amendmentContent1[index] : "";
 * 
 * 	const diffs = diff3Merge(amendmentContent1Str, prevArticleParagraph, amendmentContent2Str, { excludeFalseConflicts: true });
 * 	const array = diffs.flatMap((diff) => {
 * 	    if (diff.ok !== undefined && diff.ok.length > 0) return diff.ok;
 * 	    if (diff.conflict !== undefined && diff.conflict.b.length > 0) return diff.conflict.b;
 * 	    return [];
 * 	});
 * 	return array.join(" ");
 *     });
 * 
 *     return diffs;
 * } */



/* export function getDiffs (prevArticleContent, amendmentContent)
 * {
 *     let fArticleContent = prevArticleContent;
 *     let fAmendmentContent = amendmentContent;
 * 
 *     if (typeof fArticleContent === "string") try { fArticleContent = JSON.parse(prevArticleContent); } catch (error) {}
 *     if (typeof fAmendmentContent === "string") try { fAmendmentContent = JSON.parse(amendmentContent); } catch (error) {}
 * 
 *     const diffs = fArticleContent.map((prevArticleParagraph, index) => {
 * 	const amendmentParagraph = fAmendmentContent[index];
 * 	return diffComm(prevArticleParagraph.split(/\s+/), amendmentParagraph.split(/\s+/));
 *     });
 *     
 *     return diffs;
 * } */




/* export function applyDiffs (diffs)
 * {
 *     let result = "";
 *     diffs.forEach((part) => {
 * 	if (part.removed !== true) result += part.value;
 *     });
 * 
 *     return result;
 * }
 * 
 * export function getAndApplyDiffs (prevArticleContent, amendmentContent)
 * {
 *     return applyDiffs(getDiffs(prevArticleContent, amendmentContent));
 * } */

/* export function computeMultiDiffs (firstText, textList)
 * {
 *     const print = true;
 *     let currentText = firstText;
 * 
 *     textList.forEach((nextText) => {
 * 	let oldText = currentText;
 * 	let newText = "";
 * 	
 * 	if (print) console.log("   ");
 * 	if (print) console.log("   ");
 * 	if (print) console.log("curr |" + currentText + "|");
 * 	if (print) console.log("next |" + nextText + "|");
 * 	
 * 	const nextDiffs = getDiffs(firstText, nextText, false);
 * 	if (print) console.log([...nextDiffs]);
 * 
 * 	nextDiffs.forEach((nextPart) => {
 * 	    
 * 	    if (print) console.log("   ");
 * 	    if (print) console.log("part = |" + nextPart.value + "|");
 * 	    if (print) console.log("old  = |" + oldText + "|");
 * 
 * 	    if (nextPart.added === true)
 * 	    {
 * 		newText += nextPart.value;
 * 	    }
 * 	    
 * 	    else if (nextPart.removed === true)
 * 	    {
 * 		const oldDiffs = getDiffs(oldText, nextPart.value, false);
 * 		if (print) console.log([...oldDiffs]);
 * 
 * 		let oldIndex = oldDiffs.length-1;
 * 		if (oldDiffs[oldIndex].removed === true) { oldText = oldDiffs[oldIndex].value; oldDiffs.splice(oldIndex, 1);  }
 * 		else if (oldDiffs[oldIndex].added === true && oldIndex > 0 && oldDiffs[oldIndex-1].removed === true) { oldText = oldDiffs[oldIndex-1].value; oldDiffs.splice(oldIndex-1, 1);  }
 * 		else oldText = "";
 * 	    }
 * 
 * 	    else {
 * 		const oldDiffs = getDiffs(oldText, nextPart.value, false);
 * 		if (print) console.log([...oldDiffs]);
 * 
 * 		let oldIndex = oldDiffs.length-1;
 * 		if (oldDiffs[oldIndex].removed === true) { oldText = oldDiffs[oldIndex].value; oldDiffs.splice(oldIndex, 1);  }
 * 		else if (oldDiffs[oldIndex].added === true && oldIndex > 0 && oldDiffs[oldIndex-1].removed === true) { oldText = oldDiffs[oldIndex-1].value; oldDiffs.splice(oldIndex-1, 1);  }
 * 		else oldText = "";
 * 
 * 		oldDiffs.forEach((oldPart) => {
 * 		    if (oldPart.added !== true) newText += oldPart.value;
 * 		});
 * 	    }
 * 
 * 	    if (print) console.log("new  = |" + newText + "|");
 * 	    if (print) console.log("old  = |" + oldText + "|");
 * 	});
 * 
 * 	currentText = newText;
 *     });
 * 
 *     return currentText;
 * } */


/* export function getDiffs (prevArticleContent, amendmentContent, agg = false)
 * {
 *     const diffs = Diff.diffWords(prevArticleContent, amendmentContent);
 *     if (! agg) return diffs;
 * 
 *     let aggDiffs = [];
 *     let currentAdded = null;
 *     let currentRemoved = null;
 *     
 *     diffs.forEach((part) => {
 * 	if (part.value !== " ")
 * 	{
 * 	    if (part.added === true)
 * 	    {
 * 		if (currentAdded === null) currentAdded = part;
 * 		else {
 * 		    currentAdded.count += part.count;
 * 		    currentAdded.value += " "+part.value;
 * 		}
 * 	    }
 * 	    
 * 	    else if (part.removed === true)
 * 	    {
 * 		if (currentRemoved === null) currentRemoved = part;
 * 		else {
 * 		    currentRemoved.count += part.count;
 * 		    currentRemoved.value += " "+part.value;
 * 		}
 * 	    }
 * 
 * 	    else {
 * 		if (currentRemoved !== null)
 * 		{
 * 		    aggDiffs.push(currentRemoved);
 * 		    currentRemoved = null;
 * 		}
 * 
 * 		if (currentAdded !== null)
 * 		{
 * 		    aggDiffs.push(currentAdded);
 * 		    currentAdded = null;
 * 		}
 * 
 * 		aggDiffs.push(part);
 * 	    }
 * 	}
 *     });
 * 
 *     if (currentRemoved !== null) aggDiffs.push(currentRemoved);
 *     if (currentAdded !== null) aggDiffs.push(currentAdded);
 * 
 *     return aggDiffs;
 * } */

/* export function showDiffs (diffs)
 * {
 *     const diffContent = diffs.map((part, index) => {
 *  	const classes = part.added === true ? "px-1 text-success fw-bold" : part.removed === true ? "px-1 text-danger text-decoration-line-through" : "";
 *  	return (<span key={index} className={classes}>{part.value}</span>);
 *     });
 *     
 *     return diffContent;
 * } */

/* export function getAndShowDiffs (prevArticleContent, amendmentContent)
 * {
 *     return showDiffs(getDiffs(prevArticleContent, amendmentContent));
 * } */

/* export function applyDiffs (diffs)
 * {
 *     let result = "";
 *     diffs.forEach((part) => {
 * 	if (part.removed !== true) result += part.value;
 *     });
 * 
 *     return result;
 * } */

/* export function getAndApplyDiffs (prevArticleContent, amendmentContent)
 * {
 *     return applyDiffs(getDiffs(prevArticleContent, amendmentContent));
 * } */

/* export function computeDiffs (firstText, currentText, nextText)
 * {
 *     return computeMultiDiffs (firstText, [currentText, nextText]);
 * } */

/* export function computeMultiDiffs (firstText, textList)
 * {
 *     const print = true;
 *     let currentText = firstText;
 * 
 *     textList.forEach((nextText) => {
 * 	let oldText = currentText;
 * 	let newText = "";
 * 	
 * 	if (print) console.log("   ");
 * 	if (print) console.log("   ");
 * 	if (print) console.log("curr |" + currentText + "|");
 * 	if (print) console.log("next |" + nextText + "|");
 * 	
 * 	const nextDiffs = getDiffs(firstText, nextText, false);
 * 	if (print) console.log([...nextDiffs]);
 * 
 * 	nextDiffs.forEach((nextPart) => {
 * 	    
 * 	    if (print) console.log("   ");
 * 	    if (print) console.log("part = |" + nextPart.value + "|");
 * 	    if (print) console.log("old  = |" + oldText + "|");
 * 
 * 	    if (nextPart.added === true)
 * 	    {
 * 		newText += nextPart.value;
 * 	    }
 * 	    
 * 	    else if (nextPart.removed === true)
 * 	    {
 * 		const oldDiffs = getDiffs(oldText, nextPart.value, false);
 * 		if (print) console.log([...oldDiffs]);
 * 
 * 		let oldIndex = oldDiffs.length-1;
 * 		if (oldDiffs[oldIndex].removed === true) { oldText = oldDiffs[oldIndex].value; oldDiffs.splice(oldIndex, 1);  }
 * 		else if (oldDiffs[oldIndex].added === true && oldIndex > 0 && oldDiffs[oldIndex-1].removed === true) { oldText = oldDiffs[oldIndex-1].value; oldDiffs.splice(oldIndex-1, 1);  }
 * 		else oldText = "";
 * 	    }
 * 
 * 	    else {
 * 		const oldDiffs = getDiffs(oldText, nextPart.value, false);
 * 		if (print) console.log([...oldDiffs]);
 * 
 * 		let oldIndex = oldDiffs.length-1;
 * 		if (oldDiffs[oldIndex].removed === true) { oldText = oldDiffs[oldIndex].value; oldDiffs.splice(oldIndex, 1);  }
 * 		else if (oldDiffs[oldIndex].added === true && oldIndex > 0 && oldDiffs[oldIndex-1].removed === true) { oldText = oldDiffs[oldIndex-1].value; oldDiffs.splice(oldIndex-1, 1);  }
 * 		else oldText = "";
 * 
 * 		oldDiffs.forEach((oldPart) => {
 * 		    if (oldPart.added !== true) newText += oldPart.value;
 * 		});
 * 	    }
 * 
 * 	    if (print) console.log("new  = |" + newText + "|");
 * 	    if (print) console.log("old  = |" + oldText + "|");
 * 	});
 * 
 * 	currentText = newText;
 *     });
 * 
 *     return currentText;
 * } */
